export const formatPercentage = (
  beneficiaries: { percentage?: number }[] | null
): number => {
  const total =
    beneficiaries?.reduce(
      (acc, { percentage = 0 }) => acc + Math.round(percentage * 100),
      0
    ) ?? 0;

  return total / 100;
};
